<template>
<div class="content starting">
    <div class="login boxLogin">
        <b-row>
            <b-col class="box">
                <img src="../assets/logoVersa.png" alt="Versa Design">
                <h1 class="appname"><span>MAINTENANCE</span> APP</h1>
                <a href="" target="_blank" class="footer-link">{{ $t("messages.login.legal") }}</a>
            </b-col>
            <b-col>
                <div class="bylogin" v-if="showView ==='login'">
                    <h3>{{ $t("messages.login.signin") }}</h3>
                    <div class="form-group">
                        <b-form-input type="text" v-bind:placeholder="$t('messages.login.placeholder.email')" v-model="email"></b-form-input>
                    </div>
                    <div class="form-group">
                        <b-form-input type="password" v-bind:placeholder="$t('messages.login.placeholder.password')" v-model="password"></b-form-input>
                    </div>
                    <button class="remember" @click="showView ='remember'">{{ $t("messages.login.forgetPassword") }}</button>
                    <button class="enter" v-on:click="signIn">{{ $t("messages.login.enter") }}</button>
                    <hr>
                    <!-- <p>{{ $t("messages.login.createAccountInfo") }} <b-button size="sm" variant="link" v-on:click="showView ='signup'">{{ $t("messages.login.createAccount") }}</b-button> -->
                </div>
                <div v-else-if="showView ==='remember'">
                    <h3>{{ $t("messages.login.passwordRecovery") }}</h3>
                    <div class="form-group">
                        <b-form-input type="text" v-bind:placeholder="$t('messages.login.placeholder.email')" v-model="rememberEmail"></b-form-input>
                    </div>
                    <button class="remember" @click="showView ='login'">Cancel</button>
                    <button v-on:click="rememberPassword" :disabled="rememberEmail.length == 0">{{ $t("messages.login.request") }}</button>
                </div>
                <!-- <sign-up v-else-if="showView ==='signup'" v-bind:actionCodeSettings="actionCodeSettings" v-on:setLogin="showView ='login'" v-on:onSuccess="onSuccess" v-on:onError="onError"></sign-up> -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown right>
                    <template slot="button-content">
                        <em> {{ currentLanguage }} </em>
                    </template>
                    <b-dropdown-item v-for="(lang, i) in languages" :key="`Lang${i}`" :value="lang.key" @click="$i18n.locale = lang.code">{{ lang.name }}</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>

            </b-col>
        </b-row>
    </div>
</div>
</template>

<script>

const fb = require('../firebaseConfig.js')
import { mapState } from 'vuex'

export default {
    name: 'login',
    computed: {
        currentLanguage: function () {
            var index =  this.languages.map((o) => o.code).indexOf(this.$i18n.locale);
            return this.languages[index].name;
        },
        ...mapState(['languages', 'actionCodeSettings'])
    },
    data: function () {
        return {
            email: '',
            sendEmail: '',
            password: '',
            rememberEmail: '',
            showView: 'login'
        }
    },
    created() {
        if (fb.auth.isSignInWithEmailLink(window.location.href)) {
            var email = window.localStorage.getItem('emailForSignIn');
            if (!email) {
                email = window.prompt('Please provide your email for confirmation');
            }
            // The client SDK will parse the code from the link for you.
            fb.auth.signInWithEmailLink(email, window.location.href)
                .then((current) => {
                    window.localStorage.removeItem('emailForSignIn');
                    this.$store.commit('setCurrentUser', current.user)
                    this.$store.dispatch('fetchUserData')
                    this.$router.replace('dashboard')
                })
                .catch( (err) => {
                    this.onError(err.message);
                });
        }
    },
    methods: {
        signIn: function () {
            fb.auth.signInWithEmailAndPassword(this.email, this.password).then(
                (current) => {
            
                    // this.$store.commit('setCurrentUser', current.user)
                   // this.$store.dispatch('fetchUserData')
                   console.log('logged');
                    this.$router.replace('dashboard')
                },
                (err) => {
                    this.onError(err.message);
                }
            );
        },
        signInByEmail: function () {
            fb.auth.sendSignInLinkToEmail(this.sendEmail, this.actionCodeSettings)
                .then(() => {
                    this.onSuccess(this.$t("messages.login.requestSuccess"));
                    window.localStorage.setItem('emailForSignIn', this.sendEmail);
                })
                .catch( (err) => {
                    this.onError(err.message);
                });
        },
        rememberPassword: function () {
            fb.auth.sendPasswordResetEmail(this.rememberEmail, this.actionCodeSettings).then( (result) => {
                this.onSuccess(this.$t("messages.login.requestSuccess"));
            }).catch( (err) => {
                this.onError(err.message);
            });
        },
        onSuccess: function (msg) {
            this.$snotify.success(msg, 'Info', {
                timeout: 3000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true
            });
        },
        onError: function(msg) {
            console.log('Error. ' + msg)
            this.$snotify.error(msg, 'Error', {
                timeout: 3000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue